export const heroData = {
  backgroundImage: "https://readdy.ai/api/search-image?query=Modern%20industrial%20HVAC%20facility%20interior%20with%20precision%20air%20conditioning%20units%20and%20server%20cooling%20systems%20in%20a%20clean%20bright%20professional%20data%20center%20environment%20with%20white%20walls%20and%20metallic%20equipment&width=1920&height=600&seq=vc-hero-01&orientation=landscape",
};

export const solutionsData = {
  image: "https://readdy.ai/api/search-image?query=Professional%20HVAC%20engineer%20inspecting%20precision%20air%20conditioning%20equipment%20in%20a%20modern%20data%20center%20with%20clean%20organized%20infrastructure%20and%20technical%20control%20panels&width=800&height=500&seq=vc-sol-02&orientation=landscape",
};

export const ctaData = {
  buttonLink: "/contacto",
  image: "https://readdy.ai/api/search-image?query=Friendly%20professional%20customer%20service%20representative%20wearing%20a%20headset%20in%20a%20modern%20bright%20office%20environment%20with%20industrial%20technology%20background&width=800&height=400&seq=vc-cta-03&orientation=landscape",
};

export const servicesData = [
  {
    id: "congelation",
    image: "https://readdy.ai/api/search-image?query=Industrial%20commercial%20refrigeration%20system%20with%20large%20freezer%20units%20and%20cold%20storage%20equipment%20in%20a%20clean%20professional%20warehouse%20environment&width=600&height=380&seq=vc-srv-04&orientation=landscape",
  },
  {
    id: "hvac",
    image: "https://readdy.ai/api/search-image?query=Modern%20commercial%20HVAC%20system%20installation%20with%20ductwork%20air%20conditioning%20units%20and%20ventilation%20equipment%20in%20a%20professional%20building%20setting&width=600&height=380&seq=vc-srv-05&orientation=landscape",
  },
  {
    id: "equipment",
    image: "https://readdy.ai/api/search-image?query=Specialized%20industrial%20HVAC%20equipment%20including%20precision%20cooling%20units%20and%20thermal%20management%20systems%20in%20a%20modern%20clean%20facility&width=600&height=380&seq=vc-srv-06&orientation=landscape",
  },
  {
    id: "electrical",
    image: "https://readdy.ai/api/search-image?query=Professional%20electrical%20installation%20with%20UPS%20systems%20backup%20power%20units%20and%20electrical%20panels%20in%20a%20modern%20industrial%20facility%20with%20organized%20cables&width=600&height=380&seq=vc-srv-07&orientation=landscape",
  },
  {
    id: "energy",
    image: "https://readdy.ai/api/search-image?query=Modern%20UPS%20battery%20backup%20system%20and%20emergency%20power%20generator%20equipment%20in%20a%20professional%20data%20center%20environment%20with%20organized%20clean%20infrastructure&width=600&height=400&seq=vc-srv-08&orientation=landscape",
  },
  {
    id: "coolnet",
    image: "https://readdy.ai/api/search-image?query=Coolnet%20precision%20air%20conditioning%20unit%20in%20a%20modern%20data%20center%20environment%20with%20clean%20white%20metallic%20cooling%20equipment%20and%20organized%20server%20infrastructure&width=600&height=400&seq=vc-srv-09&orientation=landscape",
  },
];

export const statsData = {
  backgroundImage: "https://readdy.ai/api/search-image?query=Abstract%20modern%20technology%20background%20with%20subtle%20geometric%20patterns%20in%20light%20gray%20tones%20suggesting%20industrial%20precision%20and%20data%20center%20technology&width=1920&height=600&seq=vc-stat-10&orientation=landscape",
  stats: [
    { key: "clients", value: 838, suffix: "+" },
    { key: "services", value: 906, suffix: "+" },
    { key: "equipment", value: 30, suffix: "%" },
  ],
};

export const navLinks = [
  { labelKey: "nav.home", href: "/", active: true },
  { labelKey: "nav.about", href: "/nosotros" },
  {
    labelKey: "nav.services",
    href: "/servicios",
    children: [
      { labelKey: "nav.services.hvac", href: "/hvac" },
      { labelKey: "nav.services.electrical", href: "/electricos-especializados" },
      { labelKey: "nav.services.energy", href: "/energia-ups" },
      { labelKey: "nav.services.installation", href: "/instalacion-y-mantenimiento" },
      { labelKey: "nav.services.general", href: "/servicios-generales" },
    ],
  },
  {
    labelKey: "nav.coolnet",
    href: "/coolnet",
    children: [
      { labelKey: "nav.coolnet.why", href: "/coolnet/por-que-ventracore" },
      { labelKey: "nav.coolnet.pac", href: "/coolnet/aire-acondicionado-precision" },
      { labelKey: "nav.coolnet.liquid", href: "/coolnet/refrigeracion-liquida" },
      { labelKey: "nav.coolnet.ups", href: "/coolnet/sistema-ups" },
      { labelKey: "nav.coolnet.integrated", href: "/coolnet/solucion-integrada" },
    ],
  },
  { labelKey: "nav.contact", href: "/contacto" },
];

export const contactInfo = {
  phone: "477 284 7060",
  phoneHref: "tel:+524772847060",
  email: "ventas@ventracore.com.mx",
  emailHref: "mailto:ventas@ventracore.com.mx",
  whatsapp: "https://wa.me/524772847060",
};

export const clientsData = [
  { name: "Autos SS de Leon", logo: "", website: "https://www.fordssleon.mx/", image: "" },
  { name: "Euromotors del Centro", logo: "", website: "https://www.bmw.com.mx/es/distribuidores/euromotors_del_centro.html", image: "" },
  { name: "Leon Fitness", logo: "", website: "https://www.instagram.com/leon.fitness.oficial/", image: "" },
  { name: "Mitsu Motors", logo: "", website: "https://mitsubishi-motors.mx/", image: "" },
  { name: "Municipio de Leon", logo: "", website: "https://leon.gob.mx/", image: "" },
  { name: "Prograde", logo: "", website: "", image: "" },
  { name: "ICAMI", logo: "", website: "https://icami.mx/", image: "" },
  { name: "Riverland Ergonomic", logo: "", website: "", image: "" },
  { name: "Sonigas", logo: "", website: "https://www.sonigas.com.mx/", image: "" },
  { name: "Samu Mexico", logo: "", website: "", image: "" },
  { name: "Elite Motors", logo: "", website: "", image: "" },
  { name: "Centro Poliforum", logo: "", website: "https://www.poliforumleon.com.mx/", image: "" },
];

export const coolnetData = {
  image: "https://readdy.ai/api/search-image?query=Coolnet%20brand%20precision%20cooling%20unit%20product%20shot%20on%20a%20clean%20white%20professional%20background%20with%20modern%20industrial%20air%20conditioning%20equipment&width=500&height=400&seq=vc-cn-11&orientation=landscape",
};